import {
  animation,
  buttonThemeUuid,
  content,
  entranceUuid,
  fields,
  fontSizeMultiply,
  h1TagEnabled,
  hoverEffectUuid,
  iframeLink,
  layoutOption,
  moduleHeight,
  moduleHeightUnit,
  moduleStyle,
  moduleTypeSelect,
  moduleWidthSelect,
  outlineColor,
  posterGap,
  posterType,
  resizingOptionsSelect,
  submitButtonText,
  subscriptionFormStyle,
  tacs,
  tacTextAndIconColor,
  text,
  textAlignment,
  textBoxWidth,
} from '@/src/tools/contentModulesFieldName';
import { TextAlign } from '@/src/types/common';
import { randomNumber } from 'src/tools/helper';
import {
  EBackgroundType,
  ELayerType,
  EModuleHeightUnit,
  EModuleWidth,
  // EnumCarouselOptions,
  EnumModuleType,
  //EnumScrollType,
  //EnumSeoTag,
  EOverflowOption,
  EPositionOption,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveContentPageToShow,
  EResponsivePosterGap,
  EResponsivePosterType,
  EResponsiveProductToShow,
  EResponsiveResizingOption,
} from 'src/types/common/module';
import {
  EContentEnd,
  //EPreviewSize,
  SubscriptionLayoutOption,
} from 'src/types/common/SalesChannel';
import { generateNoneLinkData } from 'src/constrains/LinkLibrary/tools';
import { CURRENT_SALES_CHANNEL_UUID } from 'src/tools/constant';
import { generateKey } from 'src/tools/getUserInfo';

const moduleHeaderProperties = {
  [EnumModuleType.Carousel]: {
    name: 'Carousel',
  },
  [EnumModuleType.LongCanvas]: {
    name: 'Long Canvas',
  },
  [EnumModuleType.Poster]: { name: 'Poster' },
  [EnumModuleType.ProductCarousel]: { name: 'Carousel' },
  [EnumModuleType.ProductGrid]: { name: 'Grid Display' },
  [EnumModuleType.ProductList]: { name: 'List' },
  [EnumModuleType.Text]: { name: 'Text' },
  [EnumModuleType.Edm]: { name: 'EDM (Electronic Direct Mail)' },
  [EnumModuleType.Subscription]: { name: 'Subscription' },
  [EnumModuleType.ArticleCarousel]: { name: 'Carousel' },
  [EnumModuleType.ArticleList]: { name: 'Carousel' },
  [EnumModuleType.Video]: { name: 'Video' },
  [EnumModuleType.ResponsiveImageCarousel]: { name: 'Carousel' },
  [EnumModuleType.ResponsiveContentCarousel]: { name: 'Carousel' },
  [EnumModuleType.ResponsiveProductCarousel]: { name: 'Carousel' },
  [EnumModuleType.ResponsiveSubscription]: { name: 'Subscription' },
  [EnumModuleType.ResponsivePoster]: { name: 'Poster' },
  [EnumModuleType.ResponsiveProductGrid]: { name: 'Grid' },
  [EnumModuleType.ResponsiveContentGrid]: { name: 'Grid' },
  [EnumModuleType.ResponsiveText]: { name: 'Text' },
  [EnumModuleType.ResponsiveProductTab]: { name: 'Tab' },
  [EnumModuleType.ResponsiveContentTab]: { name: 'Tab' },
  [EnumModuleType.ResponsivePosterTab]: { name: 'Tab' },
  [EnumModuleType.ResponsiveIframe]: { name: 'Iframe' },
};

const commonProps = (type) => {
  return {
    draggableId: randomNumber(),
    visible: true,
    moduleName: moduleHeaderProperties[type].name,
  };
};

const emailField = {
  field: {
    type: 'Input',
    name: 'Email',
    fieldType: 'Email',
    uuid: 'ecbf4710-5a18-47a5-85e8-32734528acb8',
  },
  draggableId: 'Email',
  required: true,
  placeholder: 'Email',
  // hideDelete: true,
};

// const linkModuleNone = {
//   action: null,
//   item: { hasError: false },
//   label: 'None',
//   linkType: 'None',
//   uuid: null,
// };

const generateNewContentPage = () => {
  const k = generateKey(CURRENT_SALES_CHANNEL_UUID);
  const uuid = window.sessionStorage.getItem(k);
  return {
    contentPage: null,
    image: null,
    subtitle: '',
    summary: '',
    draggableId: randomNumber(),
    salesChannelUuid: uuid,
  };
};

const generateLinkImg = (amount = 0) => {
  const _r = [];
  for (let i = 0; i < amount; i++) {
    _r.push(generateNoneLinkData());
  }
  return _r;
};

const generateResponsiveImage = (name?) => {
  return {
    name: name || 'Image',
    image: null,
    imageLink: generateNoneLinkData(),
    background: false,
    autoplayEnabled: false,
    mute: false,
    layers: [],
    draggableId: randomNumber(),
    isNew: true,
  };
};

const generateTabStyle = () => {
  return {
    gapUnderTab: 12,
    regularTabColor: '#fff',
    activeTabColor: '#000',
  };
};

const generateResponsiveTextContent = () => {
  return {
    [text]: '',
    [textBoxWidth]: 1000,
    [fontSizeMultiply]: 120,
    [textAlignment]: TextAlign.LEFT,
    contentHasError: true,
  };
};

const generateResponsiveModuleStyle = () => {
  return {
    topPadding: 16,
    bottomPadding: 16,
    marginToTop: 16,
    marginToBottom: 16,
    marginToLeft: 16,
    marginToRight: 16,
    fullWidth: false,
    backgroundType: EBackgroundType.NONE,
  };
};

const generateResponsiveImageLayer = () => {
  return {
    layerType: ELayerType.BUTTON,
    buttonThemeUuid: null,
    buttonText: 'Button',
    linkModule: generateNoneLinkData(),
    marginToLeft: 0,
    marginToTop: 0,
    marginToBottom: 0,
    marginToRight: 0,
    marginToVCenter: 0,
    marginToHCenter: 0,
    hoverEffectUuid: null,
    entranceUuid: null,
    content: generateResponsiveTextContent(),
    image: null,
    draggableId: randomNumber(),
    positionOption: [EPositionOption.Center],
    imageWidth: 16,
    visible: true,
    name: 'Layer',
  };
};

const generateResponsiveText = () => {
  return {
    backgroundColor: '#fff',
    productNameColor: '#000',
    bodyTextColor: '#B9BCBF',
    listPriceColor: '#D20000',
    otherPriceColor: '#B9BCBF',
    subtitleColor: '#000',
    contentPageNameColor: '#000',
    contentPageSummaryColor: '#000',
  };
};

const generateTabPoster = (index?) => {
  return {
    draggableId: randomNumber(),
    title: `Tab ${index || 1}`,
    posterType: EResponsivePosterType.TWO_1_1,
    posters: [
      generateResponsiveImage(`Poster ${1}`),
      generateResponsiveImage(`Poster ${2}`),
    ],
  };
};

const generateTabProduct = (index?) => {
  return {
    draggableId: randomNumber(),
    title: `Tab ${index || 1}`,
    productToShow: EResponsiveProductToShow.TwoPortrait,
    buttonThemeUuid: null,
    products: [],
  };
};

const generateTabContent = (index?) => {
  // const k = generateKey(CURRENT_SALES_CHANNEL_UUID);
  // const uuid = window.localStorage.getItem(k);
  return {
    draggableId: randomNumber(),
    title: `Tab ${index || 1}`,
    contentPagesToShow: EResponsiveContentPageToShow.TwoPortrait,
    contentPages: [],
  };
};

const generateResponsiveSubscription = () => {
  const pc = {
    [moduleTypeSelect]: EnumModuleType.ResponsiveSubscription,
    [layoutOption]: SubscriptionLayoutOption.ONE_COLUMN,
    ...generateResponsiveTextContent(),
    [submitButtonText]: 'Submit',
    [buttonThemeUuid]: null,
    [moduleStyle]: generateResponsiveModuleStyle(),
    [subscriptionFormStyle]: {
      [outlineColor]: '#B9BCBF',
      [tacTextAndIconColor]: '#ffffff',
    },
    [animation]: { [entranceUuid]: null, [hoverEffectUuid]: null },
    [fontSizeMultiply]: 100,
    [textAlignment]: TextAlign.LEFT,
    [fields]: [emailField],
    [tacs]: [],
    ...commonProps(EnumModuleType.ResponsiveSubscription),
  };

  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: { ...pc, [textBoxWidth]: 560 },
    [EContentEnd.mobile]: { ...pc, [textBoxWidth]: 240 },
  };
};

const generateResponsiveImageCarousel = () => {
  const pc = {
    moduleType: EnumModuleType.ResponsiveImageCarousel,
    moduleWidth: EModuleWidth.NONE,
    autoPlay: false,
    intervalTime: 3,
    moduleStyle: generateResponsiveModuleStyle(),
    resizingOption: EResponsiveResizingOption.FIXED,
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    ...commonProps(EnumModuleType.ResponsiveImageCarousel),
    images: [],
  };
  const tablet = { ...pc, moduleWidth: EModuleWidth.NONE };
  const mobile = { ...pc, moduleWidth: EModuleWidth.NONE };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: tablet,
    [EContentEnd.mobile]: mobile,
  };
};

const generateResponsiveProductCarousel = () => {
  const pc = {
    moduleType: EnumModuleType.ResponsiveProductCarousel,
    moduleWidth: EModuleWidth.NONE,
    autoPlay: false,
    intervalTime: 3,
    leaveGap: false,
    scrollOut: 1,
    actionButtonTheme: null,
    productToShow: EResponsiveProductToShow.One,
    moduleText: generateResponsiveText(),

    moduleStyle: generateResponsiveModuleStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    ...commonProps(EnumModuleType.ResponsiveProductCarousel),
    products: [],
  };
  const tablet = { ...pc, moduleWidth: EModuleWidth.WIDE, intervalTime: 2 };
  const mobile = { ...pc, moduleWidth: EModuleWidth.WIDE, intervalTime: 2 };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: tablet,
    [EContentEnd.mobile]: mobile,
  };
};

const generateResponsiveContentPageCarousel = () => {
  const pc = {
    moduleType: EnumModuleType.ResponsiveContentCarousel,
    moduleWidth: EModuleWidth.NONE,
    autoPlay: false,
    intervalTime: 3,
    leaveGap: false,
    scrollOut: 1,
    actionButtonTheme: null,
    contentPagesToShow: EResponsiveContentPageToShow.One,
    moduleText: generateResponsiveText(),
    moduleStyle: generateResponsiveModuleStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    ...commonProps(EnumModuleType.ResponsiveContentCarousel),
    contentPages: [],
  };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: pc,
    [EContentEnd.mobile]: pc,
  };
};

const generateResponsiveProductGrid = () => {
  const pc = {
    moduleType: EnumModuleType.ResponsiveProductGrid,
    moduleWidth: EModuleWidth.WIDE,
    leaveGap: false,
    actionButtonTheme: null,
    productToShow: EResponsiveProductToShow.One,
    moduleText: generateResponsiveText(),
    moduleStyle: generateResponsiveModuleStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    ...commonProps(EnumModuleType.ResponsiveProductGrid),
    products: [],
  };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: {
      ...pc,
      overflowOption: EOverflowOption.AnotherLine,
    },
    [EContentEnd.mobile]: {
      ...pc,
      overflowOption: EOverflowOption.AnotherLine,
    },
  };
};

const generateResponsiveContentGrid = () => {
  const pc = {
    moduleType: EnumModuleType.ResponsiveContentGrid,
    moduleWidth: EModuleWidth.WIDE,
    leaveGap: false,
    contentPagesToShow: EResponsiveContentPageToShow.One,
    moduleText: generateResponsiveText(),
    moduleStyle: generateResponsiveModuleStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    ...commonProps(EnumModuleType.ResponsiveContentGrid),
    contentPages: [],
  };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: {
      ...pc,
      overflowOption: EOverflowOption.AnotherLine,
    },
    [EContentEnd.mobile]: {
      ...pc,
      overflowOption: EOverflowOption.AnotherLine,
    },
  };
};

const generateResponsiveProductTab = () => {
  //generateTabProduct
  const product = generateTabProduct();
  const draggableId = product.draggableId;
  const temp = {
    moduleType: EnumModuleType.ResponsiveProductTab,
    moduleWidth: EModuleWidth.WIDE,
    overflowOption: EOverflowOption.AnotherLine,
    leaveGap: false,
    moduleStyle: generateResponsiveModuleStyle(),
    moduleText: generateResponsiveText(),
    tabStyle: generateTabStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    selectedTab: draggableId,
    ...commonProps(EnumModuleType.ResponsiveProductTab),
    tabs: [product],
  };
  const mobileTabs = [
    {
      draggableId: randomNumber(),
      title: `Tab 1`,
      productToShow: EResponsiveProductToShow.TwoPortrait,
      buttonThemeUuid: null,
      products: [],
    },
  ];
  return {
    [EContentEnd.pc]: temp,
    [EContentEnd.tablet]: temp,
    [EContentEnd.mobile]: { ...temp, tabs: mobileTabs },
  };
};

const generateResponsiveContentTab = () => {
  //generateTabProduct
  const contentPage = generateTabContent();
  const draggableId = contentPage.draggableId;
  const temp = {
    moduleType: EnumModuleType.ResponsiveContentTab,
    moduleWidth: EModuleWidth.WIDE,
    overflowOption: EOverflowOption.AnotherLine,
    leaveGap: false,
    moduleStyle: generateResponsiveModuleStyle(),
    moduleText: generateResponsiveText(),
    tabStyle: generateTabStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    selectedTab: draggableId,
    ...commonProps(EnumModuleType.ResponsiveContentTab),
    tabs: [contentPage],
  };

  return {
    [EContentEnd.pc]: temp,
    [EContentEnd.tablet]: temp,
    [EContentEnd.mobile]: temp,
  };
};

const generateResponsiveIframe = () => {
  const temp = {
    moduleType: EnumModuleType.ResponsiveIframe,
    [iframeLink]: generateNoneLinkData(),
    [moduleHeight]: 100,
    [moduleHeightUnit]: EModuleHeightUnit.Percentage,
    [moduleWidthSelect]: EModuleWidth.FULL,
    [moduleStyle]: generateResponsiveModuleStyle(),
    ...commonProps(EnumModuleType.ResponsiveIframe),
  };
  const tm = {
    ...temp,
    [moduleWidthSelect]: EModuleWidth.WIDE,
  };

  return {
    [EContentEnd.pc]: temp,
    [EContentEnd.tablet]: tm,
    [EContentEnd.mobile]: tm,
  };
};

const generateResponsivePosterTab = () => {
  const tab = generateTabPoster();
  const draggableId = tab.draggableId;
  const temp = {
    moduleType: EnumModuleType.ResponsivePosterTab,
    moduleWidth: EModuleWidth.WIDE,
    posterGap: EResponsivePosterGap.NONE,
    resizingOption: EResponsiveResizingOption.FIXED,
    moduleStyle: generateResponsiveModuleStyle(),
    tabStyle: generateTabStyle(),
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    selectedTab: draggableId,
    ...commonProps(EnumModuleType.ResponsivePosterTab),
    tabs: [tab],
  };
  return {
    [EContentEnd.pc]: temp,
    [EContentEnd.tablet]: temp,
    [EContentEnd.mobile]: temp,
  };
};

const generateResponsivePoster = () => {
  const _commonProps = commonProps(EnumModuleType.ResponsivePoster);
  const pc = {
    ..._commonProps,
    [moduleTypeSelect]: EnumModuleType.ResponsivePoster,
    [moduleWidthSelect]: EModuleWidth.NONE,
    [posterGap]: EResponsivePosterGap.NONE,
    [posterType]: EResponsivePosterType.ONE,
    [moduleStyle]: generateResponsiveModuleStyle(),
    [resizingOptionsSelect]: EResponsiveResizingOption.FIXED,
    animation: { hoverEffectUuid: null, entranceUuid: null },
    switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
    images: [generateResponsiveImage(`Poster ${1}`)],
  };
  const tablet = {
    ...pc,
    [moduleWidthSelect]: EModuleWidth.WIDE,
  };
  const mobile = {
    ...pc,
    [moduleWidthSelect]: EModuleWidth.WIDE,
  };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: tablet,
    [EContentEnd.mobile]: mobile,
  };
};

const generateResponsiveTextEditor = () => {
  const _commonProps = commonProps(EnumModuleType.ResponsiveText);
  const pc = {
    [moduleTypeSelect]: EnumModuleType.ResponsiveText,
    [content]: generateResponsiveTextContent(),
    [moduleStyle]: generateResponsiveModuleStyle(),
    [h1TagEnabled]: false,
    ..._commonProps,
  };
  const tablet = {
    ...pc,
    [content]: {
      ...pc[content],
      [textBoxWidth]: 560,
    },
  };
  const mobile = {
    ...pc,
    [content]: {
      ...pc[content],
      [textBoxWidth]: 240,
    },
  };
  return {
    [EContentEnd.pc]: pc,
    [EContentEnd.tablet]: tablet,
    [EContentEnd.mobile]: mobile,
  };
};

const generateContentModule = (type) => {
  const dic = {
    [EnumModuleType.ResponsiveProductCarousel]:
      generateResponsiveProductCarousel,
    [EnumModuleType.ResponsiveImageCarousel]: generateResponsiveImageCarousel,
    [EnumModuleType.ResponsiveContentCarousel]:
      generateResponsiveContentPageCarousel,
    [EnumModuleType.ResponsiveSubscription]: generateResponsiveSubscription,
    [EnumModuleType.ResponsivePoster]: generateResponsivePoster,
    [EnumModuleType.ResponsiveProductGrid]: generateResponsiveProductGrid,
    [EnumModuleType.ResponsiveContentGrid]: generateResponsiveContentGrid,
    [EnumModuleType.ResponsiveText]: generateResponsiveTextEditor,
    [EnumModuleType.ResponsivePosterTab]: generateResponsivePosterTab,
    [EnumModuleType.ResponsiveProductTab]: generateResponsiveProductTab,
    [EnumModuleType.ResponsiveContentTab]: generateResponsiveContentTab,
    [EnumModuleType.ResponsiveIframe]: generateResponsiveIframe,
    //generateResponsivePoster //
  };
  if (dic[type]) {
    return dic[type]();
  } else {
    return null;
  }
};

export {
  generateContentModule,
  generateLinkImg,
  generateNewContentPage,
  generateResponsiveImage,
  generateResponsiveImageLayer,
  generateTabPoster,
  generateTabProduct,
  generateTabContent,
};
